const accordion = {
    handleTriggerClick() {
        $('.accordion__trigger').click(function() {
            const $this = $(this);
            $this.parent().toggleClass('accordion--open');
            $this.find('.accordion__icon').toggleClass('accordion__icon--up');
        });
    }
};

$(() => {
    accordion.handleTriggerClick();
});

export default accordion;
